import { type RealEstateDocumentChibanKaokuNumberRow } from "@/features/map/types";
import { isCompletePropertyRow } from "@/utils/propertyRows";

/**
 * 「次へ」ボタンのバリデーション入力パラメータ。
 */
export interface StepValidationInput {
  /** 現在表示中のステップ番号 */
  step: 1 | 2 | 3;
  /** 住所フィールドの値 */
  watchedAddress: string;
  /** 地番リスト */
  localChibanList: RealEstateDocumentChibanKaokuNumberRow[];
  /** 選択済み書類 ID の配列 */
  selectedDocuments: string[];
  /** ヒアリング項目の配列 */
  hearingItems: string[];
  /** その他書類バリデーションエラーの配列 */
  otherDocumentsErrors: string[];
  /** 郵送希望フラグ */
  needsPostalDelivery: boolean;
  /** 郵送住所 */
  postalAddress: string;
}

/**
 * 「次へ」ボタンを disable にする理由を返す。
 * disable 不要なら空文字列を返す。
 *
 * @param input バリデーション対象の入力値
 * @returns disable 理由の文字列。disable 不要なら空文字列
 */
export const getNextButtonDisabledReason = (
  input: StepValidationInput
): string => {
  const {
    step,
    watchedAddress,
    localChibanList,
    selectedDocuments,
    hearingItems,
    otherDocumentsErrors,
    needsPostalDelivery,
    postalAddress,
  } = input;

  if (step === 1) {
    if (watchedAddress.trim() === "") {
      return "住所を入力してください";
    }
    if (
      localChibanList.length === 0 ||
      !localChibanList.some(isCompletePropertyRow)
    ) {
      return "地番を入力してください";
    }
    if (
      selectedDocuments.length === 0 &&
      hearingItems.every((h) => h.trim() === "")
    ) {
      return "書類またはヒアリング項目を選択・入力してください";
    }
    if (otherDocumentsErrors.some((e) => e !== "")) {
      return "その他書類の入力内容を確認してください";
    }
    return "";
  }

  if (step === 2) {
    if (needsPostalDelivery && postalAddress.trim() === "") {
      return "発送場所（住所）を入力してください";
    }
    return "";
  }

  return "";
};
